import '../css/login.css';
import './css/adminGeneral.css';
import { Link, useNavigate } from 'react-router-dom';
import React, { useState,useEffect } from 'react';
import Axios from '../../config/index';
import ShowButton from '../ShowButton';


function LoginAdmin(props) {
    
const [username, setUsername] = useState("");
const [password, setPassword] = useState("");
const navigate = useNavigate();
const [loginStatus, setLoginStatus] = useState("");
const [loading, setLoading] = useState(false);



const [show, setShow] = useState(false);

const handleToggle = () => {
    setShow(!show);
};

const handleChange = (event) => {
    setPassword(event.target.value);
};



Axios.defaults.withCredentials = true;


const logout = () => {
    Axios
    .get('logout')
    .then((res) => {
        if (res.data.logout) {
            props.setSessionExists(false);
            navigate('/admin-login');

        } else {
        navigate('/admin-login');
        }
    })
    .catch((err) => console.log(err));
};




useEffect(() => {
    Axios
.get('session')
.then((res) => {
    if (res.data.valid) {
        if(res.data.type === "user"){
            logout();
        }else{

        }
    } 
})
.catch((err) => console.log(err));
},[]);




    useEffect(() => {
        Axios
    .get('session-admin')
    .then((res) => {
        if (res.data.valid) {
            if(res.data.type == "admin"){
                navigate('/dashboard');
            }
        } else {
            props.setSessionExists(false);
        }
    })
    .catch((err) => console.log(err));
    },[]);

    
    const login = (e) => {
        e.preventDefault();
        setLoading(true);
        props.setSessionExists(false);
        Axios.post("/loginAdmin", {
            username: username,
            password: password,
        })
        .then((response) => {
            if (response.data.message) {
                setLoginStatus(response.data.message);
                setLoading(false);
                return props.setSessionExists(false);
            } else {
                setLoading(false);
                props.setSessionExists(true);
                console.log(props.sessionExists);
                setLoginStatus("Successfully logged in.");
                navigate('/dashboard');
            }
        })
        .catch((err) => {
            setLoading(false);
            setLoginStatus("Failed to log in. Please try again.");
            return props.setSessionExists(false);
        });
    };
    
    
return (
    <>
        <section className='login'>
        <div className='container-fluid'>
        <div className='row'>
            <div className='col-lg-12 col-md-12 col-sm-12 col-xs-12'>
            <div className='login-content'>
                <h1> Login To dashboard  </h1>

                {loginStatus ? (
                <h3 className='err-msg'> {loginStatus} </h3>
                ) : null}

                <form>
                <div className='input'>
                    <label> Username </label>
                    <input
                    type='text'
                    name='username'
                    required
                    onChange={(e) => {
                        setUsername(e.target.value);
                    }}
                    />
                </div>

                <div className='input'>
                    <label> Password </label>
                    <input
                    type={show ? 'text' : 'password'}
                    name='password'
                    required
                    onChange={(e) => {
                        handleChange(e);
                        setPassword(e.target.value);
                    }}
                    />

                <ShowButton className="show-btn" show={show} handleToggle={handleToggle} />

                </div>

                {loading ? (
                    <button disabled> Authenticating ... </button>
                ) : (
                    <button onClick={login} type='submit'>
                        Login in
                    </button>
                )}
                </form>
            </div>
            </div>
        </div>
        </div>
    </section>

    </>
);
}

export default LoginAdmin;
